var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7a5 5 0 1 0 5 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.055a9 9 0 1 0 7.941 7.945"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6v3h3l3 -3h-3v-3l-3 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9l-3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGoal);
export default __webpack_public_path__ + "static/media/hero-goal.05400df85126c409527b1708a33dad2b.svg";
export { ForwardRef as ReactComponent };